import React, { useCallback } from 'react';
import media from 'styled-media-query';
import styled from 'styled-components';
import { NotificationProps } from 'src/firebase/db/Notifications';
import StyleConfig from 'src/constants/StyleConfig';

type Props = {
  notification: NotificationProps;
  onDelete: (id: string) => void;
};

const OrderBreadListItem = (props: Props) => {
  const {
    notification: { id, is_notified: isNotified, order_breads: orderBreads },
    onDelete,
  } = props;

  const wraponDelete = useCallback(
    (id: string) => {
      onDelete(id);
    },
    [onDelete],
  );

  const soldQuntity = useCallback((orders?: string[]) => (orders ? orders.length : 0), []);

  return (
    <>
      {orderBreads.map((orderBread) => (
        <div key={`${id}${orderBread.id}`}>
          <ListItem>
            <div className="orderBread">
              {isNotified ? (
                <div className="is-notified">
                  <div className="orderBread-title">{orderBread.name}</div>
                  <div className="orderBread-sold">
                    <span>現時点受注数</span>
                    <span>
                      {soldQuntity(orderBread.original_orders)}個／
                      {orderBread.stock}個
                    </span>
                  </div>
                  <div className="orderBread-notified">配信済み</div>
                </div>
              ) : (
                <div className="is-not-notified">
                  <div className="orderBread-title">{orderBread.name}</div>
                  <div className="orderBread-stock">
                    <span>販売数</span>
                    <span>
                      <span>{orderBread.stock}</span>
                      <span>個</span>
                    </span>
                  </div>
                  <div className="orderBread-cancel">
                    <span onClick={() => wraponDelete(orderBread.id)}>配信をキャンセルする</span>
                  </div>
                </div>
              )}
            </div>
          </ListItem>
        </div>
      ))}
    </>
  );
};

const ListItem = styled.div`
  background-color: #fff;
  color: ${StyleConfig.COLOR.TEXT_COLOR};
  margin-bottom: ${StyleConfig.HELPER.M16};
  border-radius: 4px;
  padding: 20px;
  font-size: 16px;
  font-weight: bold;
  line-height: ${20 / 16};

  .orderBread {
    display: inline-flex;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;

    .is-notified,
    .is-not-notified {
      display: inline-flex;
      align-items: flex-end;
      width: 100%;
      flex-wrap: wrap;

      .orderBread-title {
        flex: 40%;
        padding-right: 20px;
      }

      ${media.greaterThan('medium')`
        align-items: center;
        flex-wrap: nowrap;
        .orderBread-title {
          max-width: 300px;
          padding-right: 10px;
          display : flex;
          flex-grow: 1;
          flex-shrink: 0;
        }
      `};
    }

    /* 配信前 */
    .is-not-notified {
      .orderBread-stock {
        flex-shrink: 1;
        display: inline-flex;
        > span {
          &:first-child {
            flex-shrink: 1;
            text-align: right;
            margin-right: 12px;
          }
          &:last-child {
            flex-grow: 1;
          }
        }
      }
      .orderBread-cancel {
        margin-top: ${StyleConfig.HELPER.M16};
        flex: 100%;
        cursor: pointer;
        color: ${StyleConfig.COLOR.RED};
        text-align: center;
        text-decoration: underline;
      }
      ${media.greaterThan('medium')`
        .orderBread-stock {
          margin-left: auto;
          flex: 2;
        }
        .orderBread-cancel {
          margin-top: 0;
          flex: 3;
          text-align: right;
        }
      `};
    }

    /* 配信後 */
    .is-notified {
      .orderBread-title {
        margin-bottom: ${StyleConfig.HELPER.M16};
        flex: 100%;
      }
      .orderBread-sold {
        order: 2;
        flex-shrink: 1;
        display: inline-flex;
        > span {
          &:first-child {
            flex-shrink: 1;
            margin-right: 12px;
            text-align: right;
          }
          &:last-child {
            flex-grow: 1;
          }
        }
      }
      .orderBread-notified {
        color: ${StyleConfig.COLOR.TEXT_GRAY};
        margin-right: auto;
      }
      ${media.greaterThan('medium')`
        .orderBread-title {
          margin-bottom: 0;
        }
        .orderBread-sold {
          margin-left: auto;
          flex: 2;
          order: 1;
        }
        .orderBread-notified {
          margin-top: 0;
          flex: 1;
          order: 2;
          text-align: right;
        }
      `};

      .orderBread-sold,
      .orderBread-notified {
        ${StyleConfig.MEDIAQUERY.lessThan('xs')`
          font-size: ${StyleConfig.TYPO.TEXT};
        `};
      }
    }
  }
`;

export default OrderBreadListItem;
